module.exports = __webpack_public_path__ + "img/logo-login.2b503dc2.png";